import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { HeaderIcons } from 'swag-client-common/components/partials/header-icons/header-icons';
import { productInformationDispatcher } from '../../../../../redux/product/product.dispatchers';
import { productInformationSelector } from '../../../../../redux/related-product-builder-popup/related-product.selectors';
import detailsClasses from '../details/details.scss';
import classes from './product-information.scss';
class ProductInformation extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleInstantQuoteClick = this.handleInstantQuoteClick.bind(this);
  }
  handleInstantQuoteClick(e) {
    const {
      onClickInstantQuote
    } = this.props;
    e.preventDefault();
    onClickInstantQuote();
  }
  render() {
    const {
      name,
      descr,
      productId,
      forbiddenForInventory,
      acceptableForBox
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.main
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.heading
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.title,
      "data-product-id": productId
    }, name.split(' ').map(word => word[0].toUpperCase() + word.slice(1)).join(' ')), /*#__PURE__*/React.createElement(HeaderIcons, {
      isForbiddenForInventory: forbiddenForInventory,
      acceptableForBox: acceptableForBox,
      isLimitedEdition: false
    })), /*#__PURE__*/React.createElement("p", {
      className: classnames(detailsClasses.gray, classes.description)
    }, descr)));
  }
}
export default connect(productInformationSelector, productInformationDispatcher)(ProductInformation);